import React from 'react'
import { SHARED_COLORS, hexToRGBA } from '../../utils'
import { WemoloTypography } from '../Wemolo'
import styles from './Completed.module.css'

interface CompletedProps {
    title?: string
    subtitle?: string
    color?: string
}

export const Completed = ({
    title = 'Completed!',
    subtitle = 'The task has been successfully completed.',
    color = SHARED_COLORS.SAVE
}: CompletedProps) => {
    return (
        <div className={styles.root}>
            <div className={styles.iconCircle} style={{ backgroundColor: hexToRGBA(color, 0.15) }}>
                <svg
                    width="40"
                    height="40"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke={color}
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <polyline points="20 6 9 17 4 12" />
                </svg>
            </div>
            <WemoloTypography variant="headline-small" tag="div" className={styles.title}>
                {title}
            </WemoloTypography>
            <WemoloTypography variant="body-small" tag="div" className={styles.subtitle}>
                {subtitle}
            </WemoloTypography>
        </div>
    )
}
